<script setup>
import { ref } from 'vue';
import ContactsModal from './ContactsModal.vue';
import { openUrlWithFakeTag } from '@/Services/agendartMobileAppUtils';
import { getWhatsAppUrl } from '@/Services/websiteContactUtils';


const props = defineProps({
    web_site: Object,
    selfSchedulingLink: String,
    headingTag: {
        type: String,
        default: 'h1',
    },
});


const color = ref(props.web_site.color)
const bannerAlignment = props.web_site.banner_text_alignment || 'left'
const openSelfScheduling = () => {
    openUrlWithFakeTag(props.selfSchedulingLink, '_blank');
}

const openWhatsApp = () => {
    const url = getWhatsAppUrl(props.web_site.contact?.whats_app, 'Olá, gostaria de saber mais sobre seu atendimento.');
    if (url) openUrlWithFakeTag(url, '_blank');
    else openDialog();
}

// Open dialog
const isDialogOpen = ref(false);
const openDialog = () => { isDialogOpen.value = true; };
const closeDialog = () => { isDialogOpen.value = false; };

</script>
<template>
    <section id="banner-principal" aria-label="Banner principal" class="w-full bg-white px-4 py-4 md:px-6 md:py-6">
        <div class="container relative mx-auto flex aspect-[8/3] min-h-[11rem] items-center overflow-hidden rounded-3xl border border-gray-200/80 bg-cover bg-center bg-no-repeat text-white shadow-[0_8px_24px_rgba(31,41,55,0.10)] md:min-h-0"
            :style="{ backgroundImage: `url('${web_site.image?.main_banner_path_url || '/assets/images/banner.jpg'}')` }">
            <div class="relative mx-auto flex w-full px-5 py-6 md:px-10 md:py-12 lg:px-12 lg:py-16" :class="{
                'justify-start text-left': bannerAlignment === 'left',
                'justify-center text-center': bannerAlignment === 'center',
                'justify-end text-right': bannerAlignment === 'right'
            }">
                <div class="flex min-w-0 max-w-2xl flex-col" :class="{
                    'items-start': bannerAlignment === 'left',
                    'items-center': bannerAlignment === 'center',
                    'items-end': bannerAlignment === 'right'
                }">
                    <component :is="headingTag" id="website-banner-title" v-if="web_site.text?.name"
                        class="max-w-full rounded-sm bg-white px-3 py-2 text-2xl font-bold uppercase leading-tight tracking-wide md:text-4xl"
                        :style="{ color }">
                        {{ web_site.text.name }}
                    </component>
                    <p v-if="web_site.text?.specialty"
                        class="mt-3 max-w-full rounded-md px-4 py-2 text-sm font-medium uppercase tracking-wide text-black md:px-6 md:text-base"
                        :style="{ backgroundColor: `color-mix(in srgb, ${color} 30%, white 70%)` }">
                        {{ web_site.text.specialty }}
                    </p>
                    <button type="button" @click="selfSchedulingLink ? openSelfScheduling() : openWhatsApp()"
                        class="mt-4 inline-flex max-w-full items-center gap-2 rounded-full px-4 py-3 text-sm font-semibold text-white shadow-lg transition hover:brightness-95 md:px-6"
                        :style="{ backgroundColor: color }">
                        <i class="fa-regular fa-calendar"></i>
                        {{ $t('schedule_an_appointment') }}
                    </button>
                </div>
            </div>
        </div>
    </section>


    <ContactsModal :visible="isDialogOpen" @close="closeDialog" :web_site="web_site"
        :selfSchedulingLink="selfSchedulingLink" />


</template>
